export const whatIsPathNodes = [
  {
    id: "214.98.126.104",
    type: "custom",
    position: { x: 1065, y: 1280 },
    className: "server-small",
    data: { label: "214.98.126.104" },
    dragHandle: "noDrag",
  },
  {
    id: "161.76.18.151",
    type: "custom",
    position: { x: 1165, y: 1310 },
    className: "server-small",
    data: { label: "161.76.18.151" },
    dragHandle: "noDrag",
  },
  {
    id: "187.219.83.42",
    type: "custom",
    position: { x: 800, y: 1280 },
    className: "server-small",
    data: { label: "187.219.83.42" },
    dragHandle: "noDrag",
  },
  {
    id: "164.176.197.211",
    type: "custom",
    position: { x: 785, y: 1020 },
    className: "server-small",
    data: { label: "164.176.197.211" },
    dragHandle: "noDrag",
  },
  {
    id: "18.24.34.114",
    type: "custom",
    position: { x: 800, y: 900 },
    className: "server-small",
    data: { label: "18.24.34.114" },
    dragHandle: "noDrag",
  },
  {
    id: "31.172.218.103",
    type: "custom",
    position: { x: 535, y: 1300 },
    className: "server-small",
    data: { label: "31.172.218.103" },
    dragHandle: "noDrag",
  },
  {
    id: "50.241.244.156",
    type: "custom",
    position: { x: 605, y: 1400 },
    className: "server-small",
    data: { label: "50.241.244.156" },
    dragHandle: "noDrag",
  },

  {
    id: "4.241.146.124",
    type: "custom",
    position: { x: 325, y: 1780 },
    className: "server-small",
    data: { label: "4.241.146.124" },
    dragHandle: "noDrag",
  },
  {
    id: "152.209.153.144",
    type: "custom",
    position: { x: 355, y: 1200 },
    className: "server-small",
    data: { label: "152.209.153.144" },
    dragHandle: "noDrag",
  },
  {
    id: "24.139.17.240",
    type: "custom",
    position: { x: 535, y: 1000 },
    className: "server-small",
    data: { label: "24.139.17.240" },
    dragHandle: "noDrag",
  },
  {
    id: "227.81.247.134",
    type: "custom",
    position: { x: 795, y: 1400 },
    className: "server-small",
    data: { label: "227.81.247.134" },
    dragHandle: "noDrag",
  },
  {
    id: "9.160.41.252",
    type: "custom",
    position: { x: 825, y: 1450 },
    className: "server-small",
    data: { label: "9.160.41.252" },
    dragHandle: "noDrag",
  },
  {
    id: "197.54.1.189",
    type: "custom",
    position: { x: 925, y: 1650 },
    className: "server-small",
    data: { label: "197.54.1.189" },
    dragHandle: "noDrag",
  },
  {
    id: "150.113.117.10",
    type: "custom",
    position: { x: 955, y: 2040 },
    className: "server-small",
    data: { label: "150.113.117.10" },
    dragHandle: "noDrag",
  },
  {
    id: "9.61.107.6",
    type: "custom",
    position: { x: 575, y: 1530 },
    className: "server-small",
    data: { label: "9.61.107.6" },
    dragHandle: "noDrag",
  },
  {
    id: "21.253.248.33",
    type: "custom",
    position: { x: 895, y: 1580 },
    className: "server-small",
    data: { label: "21.253.248.33" },
    dragHandle: "noDrag",
  },
  {
    id: "197.54.1.189",
    type: "custom",
    position: { x: 1055, y: 1520 },
    className: "server-small",
    data: { label: "197.54.1.189" },
    dragHandle: "noDrag",
  },
  {
    id: "98.131.154.187",
    type: "custom",
    position: { x: 1095, y: 1420 },
    className: "server-small",
    data: { label: "98.131.154.187" },
    dragHandle: "noDrag",
  },
  {
    id: "72.2.16.86",
    type: "custom",
    position: { x: 1295, y: 1420 },
    className: "server-small",
    data: { label: "72.2.16.86" },
    dragHandle: "noDrag",
  },
  {
    id: "241.56.61.247",
    type: "custom",
    position: { x: 1195, y: 1750 },
    className: "server-small",
    data: { label: "241.56.61.247" },
    dragHandle: "noDrag",
  },
  {
    id: "72.83.135.1",
    type: "custom",
    position: { x: 1485, y: 1550 },
    className: "server-small",
    data: { label: "72.83.135.1" },
    dragHandle: "noDrag",
  },
  {
    id: "152.56.204.194",
    type: "custom",
    position: { x: 1225, y: 1180 },
    className: "server-small",
    data: { label: "152.56.204.194" },
    dragHandle: "noDrag",
  },
  {
    id: "1.233.70.18",
    type: "custom",
    position: { x: 1525, y: 1220 },
    className: "server-small",
    data: { label: "1.233.70.18" },
    dragHandle: "noDrag",
  },
  {
    id: "238.88.35.10",
    type: "custom",
    position: { x: 1405, y: 1020 },
    className: "server-small",
    data: { label: "238.88.35.10" },
    dragHandle: "noDrag",
  },
  {
    id: "255.136.37.41",
    type: "custom",
    position: { x: 1365, y: 850 },
    className: "server-small",
    data: { label: "255.136.37.41" },
    dragHandle: "noDrag",
  },
  {
    id: "197.234.165.5",
    type: "custom",
    position: { x: 1865, y: 890 },
    className: "server-small",
    data: { label: "197.234.165.5" },
    dragHandle: "noDrag",
  },
  {
    id: "12.17.193.233",
    type: "custom",
    position: { x: 1305, y: 690 },
    className: "server-small",
    data: { label: "12.17.193.233" },
    dragHandle: "noDrag",
  },
  {
    id: "60.47.202.91",
    type: "custom",
    position: { x: 955, y: 990 },
    className: "server-small",
    data: { label: "60.47.202.91" },
    dragHandle: "noDrag",
  },
  {
    id: "94.201.149.236",
    type: "custom",
    position: { x: 955, y: 720 },
    className: "server-small",
    data: { label: "94.201.149.236" },
    dragHandle: "noDrag",
  },
  {
    id: "171.164.198.139",
    type: "custom",
    position: { x: 1195, y: 720 },
    className: "server-small",
    data: { label: "171.164.198.139" },
    dragHandle: "noDrag",
  },
  {
    id: "165.17.12.227",
    type: "custom",
    position: { x: 1075, y: 570 },
    className: "server-small",
    data: { label: "165.17.12.227" },
    dragHandle: "noDrag",
  },
  {
    id: "147.1.12.217",
    type: "custom",
    position: { x: 1205, y: 1590 },
    className: "server-small",
    data: { label: "147.1.12.217" },
    dragHandle: "noDrag",
  },
  {
    id: "86.199.13.22",
    type: "custom",
    position: { x: 365, y: 650 },
    className: "server-small",
    data: { label: "86.199.13.22" },
    dragHandle: "noDrag",
  },

  /* //////////////////////////////////////////////////// */
  /*  klienti */
  /* //////////////////////////////////////////////////// */

  {
    id: "184.180.21.31",
    type: "custom",
    position: { x: 1005, y: 1280 },
    className: "client-small",
    data: { label: "184.180.21.31" },
    dragHandle: "noDrag",
  },
  {
    id: "112.131.144.230",
    type: "custom",
    position: { x: 995, y: 1350 },
    className: "client-small",
    data: { label: "112.131.144.230" },
    dragHandle: "noDrag",
  },
  {
    id: "39.181.71.66",
    type: "custom",
    position: { x: 905, y: 1220 },
    className: "client-small",
    data: { label: "39.181.71.66" },
    dragHandle: "noDrag",
  },
  {
    id: "251.108.3.43",
    type: "custom",
    position: { x: 795, y: 1200 },
    className: "client-small",
    data: { label: "251.108.3.43" },
    dragHandle: "noDrag",
  },
  {
    id: "127.77.4.239",
    type: "custom",
    position: { x: 965, y: 1100 },
    className: "client-small",
    data: { label: "127.77.4.239" },
    dragHandle: "noDrag",
  },
  {
    id: "2.190.80.23",
    type: "custom",
    position: { x: 525, y: 1200 },
    className: "client-small",
    data: { label: "2.190.80.23" },
    dragHandle: "noDrag",
  },
  {
    id: "121.143.228.41",
    type: "custom",
    position: { x: 695, y: 1340 },
    className: "client-small",
    data: { label: "121.143.228.41" },
    dragHandle: "noDrag",
  },
  {
    id: "2.197.104.62",
    type: "custom",
    position: { x: 575, y: 1640 },
    className: "client-small",
    data: { label: "2.197.104.62" },
    dragHandle: "noDrag",
  },
  {
    id: "159.136.10.164",
    type: "custom",
    position: { x: 305, y: 1700 },
    className: "client-small",
    data: { label: "159.136.10.164" },
    dragHandle: "noDrag",
  },
  {
    id: "210.78.90.69",
    type: "custom",
    position: { x: 495, y: 1130 },
    className: "client-small",
    data: { label: "210.78.90.69" },
    dragHandle: "noDrag",
  },
  {
    id: "255.150.14.24",
    type: "custom",
    position: { x: 345, y: 1250 },
    className: "client-small",
    data: { label: "255.150.14.24" },
    dragHandle: "noDrag",
  },
  {
    id: "191.179.223.144",
    type: "custom",
    position: { x: 855, y: 1360 },
    className: "client-small",
    data: { label: "191.179.223.144" },
    dragHandle: "noDrag",
  },
  {
    id: "122.185.172.94",
    type: "custom",
    position: { x: 825, y: 1500 },
    className: "client-small",
    data: { label: "122.185.172.94" },
    dragHandle: "noDrag",
  },
  {
    id: "183.153.175.41",
    type: "custom",
    position: { x: 955, y: 1850 },
    className: "client-small",
    data: { label: "183.153.175.41" },
    dragHandle: "noDrag",
  },
  {
    id: "91.36.193.244",
    type: "custom",
    position: { x: 1205, y: 1950 },
    className: "client-small",
    data: { label: "91.36.193.244" },
    dragHandle: "noDrag",
  },
  {
    id: "13.240.139.88",
    type: "custom",
    position: { x: 515, y: 1470 },
    className: "client-small",
    data: { label: "13.240.139.88" },
    dragHandle: "noDrag",
  },
  {
    id: "178.26.52.107",
    type: "custom",
    position: { x: 855, y: 1720 },
    className: "client-small",
    data: { label: "178.26.52.107" },
    dragHandle: "noDrag",
  },
  {
    id: "59.4.74.139",
    type: "custom",
    position: { x: 1155, y: 1470 },
    className: "client-small",
    data: { label: "59.4.74.139" },
    dragHandle: "noDrag",
  },
  {
    id: "58.200.71.105",
    type: "custom",
    position: { x: 1005, y: 1460 },
    className: "client-small",
    data: { label: "58.200.71.105" },
    dragHandle: "noDrag",
  },
  {
    id: "205.37.104.11",
    type: "custom",
    position: { x: 1205, y: 1450 },
    className: "client-small",
    data: { label: "205.37.104.11" },
    dragHandle: "noDrag",
  },
  {
    id: "123.47.39.33",
    type: "custom",
    position: { x: 1145, y: 1700 },
    className: "client-small",
    data: { label: "123.47.39.33" },
    dragHandle: "noDrag",
  },
  {
    id: "100.235.0.71",
    type: "custom",
    position: { x: 1455, y: 1500 },
    className: "client-small",
    data: { label: "100.235.0.71" },
    dragHandle: "noDrag",
  },
  {
    id: "80.4.44.38",
    type: "custom",
    position: { x: 1205, y: 1245 },
    className: "client-small",
    data: { label: "80.4.44.38" },
    dragHandle: "noDrag",
  },
  {
    id: "130.153.199.52",
    type: "custom",
    position: { x: 1725, y: 1120 },
    className: "client-small",
    data: { label: "130.153.199.52" },
    dragHandle: "noDrag",
  },
  {
    id: "68.240.167.252",
    type: "custom",
    position: { x: 1305, y: 1120 },
    className: "client-small",
    data: { label: "68.240.167.252" },
    dragHandle: "noDrag",
  },
  {
    id: "204.205.103.157",
    type: "custom",
    position: { x: 1305, y: 990 },
    className: "client-small",
    data: { label: "204.205.103.157" },
    dragHandle: "noDrag",
  },
  {
    id: "24.44.1.71",
    type: "custom",
    position: { x: 1915, y: 790 },
    className: "client-small",
    data: { label: "24.44.1.71" },
    dragHandle: "noDrag",
  },
  {
    id: "47.61.220.14",
    type: "custom",
    position: { x: 1395, y: 650 },
    className: "client-small",
    data: { label: "47.61.220.14" },
    dragHandle: "noDrag",
  },
  {
    id: "182.241.87.10",
    type: "custom",
    position: { x: 905, y: 930 },
    className: "client-small",
    data: { label: "182.241.87.10" },
    dragHandle: "noDrag",
  },
  {
    id: "210.139.78.195",
    type: "custom",
    position: { x: 975, y: 670 },
    className: "client-small",
    data: { label: "210.139.78.195" },
    dragHandle: "noDrag",
  },
  {
    id: "116.41.5.210",
    type: "custom",
    position: { x: 1025, y: 790 },
    className: "client-small",
    data: { label: "116.41.5.210" },
    dragHandle: "noDrag",
  },
  {
    id: "110.184.228.105",
    type: "custom",
    position: { x: 1175, y: 540 },
    className: "client-small",
    data: { label: "110.184.228.105" },
    dragHandle: "noDrag",
  },
  {
    id: "3.188.222.146",
    type: "custom",
    position: { x: 1295, y: 1590 },
    className: "client-small",
    data: { label: "3.188.222.146" },
    dragHandle: "noDrag",
  },
  {
    id: "152.177.76.80",
    type: "custom",
    position: { x: 285, y: 620 },
    className: "client-small",
    data: { label: "152.177.76.80" },
    dragHandle: "noDrag",
  },
  /* //////////////////////////////////////////////////// */
  /*  gateways  */
  /* //////////////////////////////////////////////////// */
  {
    id: "147.96.108.21",
    type: "custom",
    position: { x: 1095, y: 1330 },
    className: "gateway-small",
    data: { label: "147.96.108.21" },
    dragHandle: "noDrag",
  },
  {
    id: "153.137.234.244",
    type: "custom",
    position: { x: 1125, y: 1230 },
    className: "gateway-small",
    data: { label: "153.137.234.244" },
    dragHandle: "noDrag",
  },
  {
    id: "60.189.8.165",
    type: "custom",
    position: { x: 1215, y: 1310 },
    className: "gateway-small",
    data: { label: "60.189.8.165" },
    dragHandle: "noDrag",
  },
  {
    id: "141.232.212.227",
    type: "custom",
    position: { x: 885, y: 1320 },
    className: "gateway-small",
    data: { label: "141.232.212.227" },
    dragHandle: "noDrag",
  },
  {
    id: "152.13.188.174",
    type: "custom",
    position: { x: 815, y: 1167 },
    className: "gateway-small",
    data: { label: "152.13.188.174" },
    dragHandle: "noDrag",
  },
  {
    id: "192.225.154.100",
    type: "custom",
    position: { x: 1005, y: 900 },
    className: "gateway-small",
    data: { label: "192.225.154.100" },
    dragHandle: "noDrag",
  },
  {
    id: "187.132.52.96",
    type: "custom",
    position: { x: 905, y: 900 },
    className: "gateway-small",
    data: { label: "187.132.52.96" },
    dragHandle: "noDrag",
  },
  {
    id: "203.101.73.159",
    type: "custom",
    position: { x: 895, y: 1000 },
    className: "gateway-small",
    data: { label: "203.101.73.159" },
    dragHandle: "noDrag",
  },
  {
    id: "85.125.75.64",
    type: "custom",
    position: { x: 1145, y: 900 },
    className: "gateway-small",
    data: { label: "85.125.75.64" },
    dragHandle: "noDrag",
  },
  {
    id: "43.84.67.114",
    type: "custom",
    position: { x: 435, y: 1320 },
    className: "gateway-small",
    data: { label: "43.84.67.114" },
    dragHandle: "noDrag",
  },
  {
    id: "211.67.180.202",
    type: "custom",
    position: { x: 985, y: 1200 },
    className: "gateway-small",
    data: { label: "211.67.180.202" },
    dragHandle: "noDrag",
  },
  {
    id: "223.4.8.20",
    type: "custom",
    position: { x: 605, y: 1480 },
    className: "gateway-small",
    data: { label: "223.4.8.20" },
    dragHandle: "noDrag",
  },
  {
    id: "217.111.129.107",
    type: "custom",
    position: { x: 455, y: 1580 },
    className: "gateway-small",
    data: { label: "217.111.129.107" },
    dragHandle: "noDrag",
  },
  {
    id: "90.202.79.101",
    type: "custom",
    position: { x: 435, y: 1680 },
    className: "gateway-small",
    data: { label: "90.202.79.101" },
    dragHandle: "noDrag",
  },
  {
    id: "86.207.231.189",
    type: "custom",
    position: { x: 435, y: 1780 },
    className: "gateway-small",
    data: { label: "86.207.231.189" },
    dragHandle: "noDrag",
  },
  {
    id: "195.13.133.245",
    type: "custom",
    position: { x: 385, y: 1880 },
    className: "gateway-small",
    data: { label: "195.13.133.245" },
    dragHandle: "noDrag",
  },
  {
    id: "70.71.155.180",
    type: "custom",
    position: { x: 465, y: 1100 },
    className: "gateway-small",
    data: { label: "70.71.155.180" },
    dragHandle: "noDrag",
  },
  {
    id: "127.230.6.154",
    type: "custom",
    position: { x: 475, y: 1050 },
    className: "gateway-small",
    data: { label: "127.230.6.154" },
    dragHandle: "noDrag",
  },
  {
    id: "194.112.46.82",
    type: "custom",
    position: { x: 305, y: 690 },
    className: "gateway-small",
    data: { label: "194.112.46.82" },
    dragHandle: "noDrag",
  },
  {
    id: "139.171.251.254",
    type: "custom",
    position: { x: 445, y: 1070 },
    className: "gateway-small",
    data: { label: "139.171.251.254" },
    dragHandle: "noDrag",
  },
  {
    id: "12.25.68.13",
    type: "custom",
    position: { x: 705, y: 1400 },
    className: "gateway-small",
    data: { label: "12.25.68.13" },
    dragHandle: "noDrag",
  },
  {
    id: "252.141.62.183",
    type: "custom",
    position: { x: 785, y: 1350 },
    className: "gateway-small",
    data: { label: "252.141.62.183" },
    dragHandle: "noDrag",
  },
  {
    id: "244.44.72.92",
    type: "custom",
    position: { x: 505, y: 1260 },
    className: "gateway-small",
    data: { label: "244.44.72.92" },
    dragHandle: "noDrag",
  },
  {
    id: "245.23.186.119",
    type: "custom",
    position: { x: 505, y: 1380 },
    className: "gateway-small",
    data: { label: "245.23.186.119" },
    dragHandle: "noDrag",
  },
  {
    id: "206.110.156.51",
    type: "custom",
    position: { x: 475, y: 1180 },
    className: "gateway-small",
    data: { label: "206.110.156.51" },
    dragHandle: "noDrag",
  },
  {
    id: "217.116.75.71",
    type: "custom",
    position: { x: 995, y: 1500 },
    className: "gateway-small",
    data: { label: "217.116.75.71" },
    dragHandle: "noDrag",
  },
  {
    id: "253.170.131.59",
    type: "custom",
    position: { x: 905, y: 1800 },
    className: "gateway-small",
    data: { label: "253.170.131.59" },
    dragHandle: "noDrag",
  },
  {
    id: "148.249.83.146",
    type: "custom",
    position: { x: 1155, y: 1900 },
    className: "gateway-small",
    data: { label: "148.249.83.146" },
    dragHandle: "noDrag",
  },
  {
    id: "70.184.56.117",
    type: "custom",
    position: { x: 1195, y: 1850 },
    className: "gateway-small",
    data: { label: "70.184.56.117" },
    dragHandle: "noDrag",
  },
  {
    id: "100.0.214.167",
    type: "custom",
    position: { x: 1075, y: 1780 },
    className: "gateway-small",
    data: { label: "100.0.214.167" },
    dragHandle: "noDrag",
  },
  {
    id: "132.61.8.225",
    type: "custom",
    position: { x: 995, y: 1700 },
    className: "gateway-small",
    data: { label: "132.61.8.225" },
    dragHandle: "noDrag",
  },
  {
    id: "146.252.110.200",
    type: "custom",
    position: { x: 715, y: 1590 },
    className: "gateway-small",
    data: { label: "146.252.110.200" },
    dragHandle: "noDrag",
  },
  {
    id: "111.175.133.151",
    type: "custom",
    position: { x: 895, y: 1500 },
    className: "gateway-small",
    data: { label: "111.175.133.151" },
    dragHandle: "noDrag",
  },
  {
    id: "36.91.134.142",
    type: "custom",
    position: { x: 955, y: 1420 },
    className: "gateway-small",
    data: { label: "36.91.134.142" },
    dragHandle: "noDrag",
  },
  {
    id: "81.8.198.111",
    type: "custom",
    position: { x: 1020, y: 1400 },
    className: "gateway-small",
    data: { label: "81.8.198.111" },
    dragHandle: "noDrag",
  },
  {
    id: "255.172.212.254",
    type: "custom",
    position: { x: 1205, y: 1500 },
    className: "gateway-small",
    data: { label: "255.172.212.254" },
    dragHandle: "noDrag",
  },
  {
    id: "244.146.178.108",
    type: "custom",
    position: { x: 1305, y: 1750 },
    className: "gateway-small",
    data: { label: "244.146.178.108" },
    dragHandle: "noDrag",
  },
  {
    id: "80.103.55.164",
    type: "custom",
    position: { x: 1275, y: 1690 },
    className: "gateway-small",
    data: { label: "80.103.55.164" },
    dragHandle: "noDrag",
  },
  {
    id: "62.136.182.25",
    type: "custom",
    position: { x: 1305, y: 1800 },
    className: "gateway-small",
    data: { label: "62.136.182.25" },
    dragHandle: "noDrag",
  },
  {
    id: "94.96.165.173",
    type: "custom",
    position: { x: 1405, y: 1550 },
    className: "gateway-small",
    data: { label: "94.96.165.173" },
    dragHandle: "noDrag",
  },
  {
    id: "155.21.161.111",
    type: "custom",
    position: { x: 1405, y: 1390 },
    className: "gateway-small",
    data: { label: "155.21.161.111" },
    dragHandle: "noDrag",
  },
  {
    id: "9.15.69.218",
    type: "custom",
    position: { x: 1405, y: 1240 },
    className: "gateway-small",
    data: { label: "9.15.69.218" },
    dragHandle: "noDrag",
  },
  {
    id: "219.238.233.252",
    type: "custom",
    position: { x: 1365, y: 1600 },
    className: "gateway-small",
    data: { label: "219.238.233.252" },
    dragHandle: "noDrag",
  },
  {
    id: "154.3.202.173",
    type: "custom",
    position: { x: 1225, y: 1100 },
    className: "gateway-small",
    data: { label: "154.3.202.173" },
    dragHandle: "noDrag",
  },
  {
    id: "252.241.212.237",
    type: "custom",
    position: { x: 1725, y: 1320 },
    className: "gateway-small",
    data: { label: "252.241.212.237" },
    dragHandle: "noDrag",
  },
  {
    id: "207.83.12.80",
    type: "custom",
    position: { x: 1475, y: 1100 },
    className: "gateway-small",
    data: { label: "207.83.12.80" },
    dragHandle: "noDrag",
  },
  {
    id: "110.53.112.104",
    type: "custom",
    position: { x: 1575, y: 1000 },
    className: "gateway-small",
    data: { label: "110.53.112.104" },
    dragHandle: "noDrag",
  },
  {
    id: "226.93.229.239",
    type: "custom",
    position: { x: 1305, y: 910 },
    className: "gateway-small",
    data: { label: "226.93.229.239" },
    dragHandle: "noDrag",
  },
  {
    id: "255.44.167.4",
    type: "custom",
    position: { x: 1765, y: 790 },
    className: "gateway-small",
    data: { label: "255.44.167.4" },
    dragHandle: "noDrag",
  },
  {
    id: "45.210.194.225",
    type: "custom",
    position: { x: 1355, y: 600 },
    className: "gateway-small",
    data: { label: "45.210.194.225" },
    dragHandle: "noDrag",
  },
  {
    id: "236.4.122.206",
    type: "custom",
    position: { x: 805, y: 1550 },
    className: "gateway-small",
    data: { label: "236.4.122.206" },
    dragHandle: "noDrag",
  },
  {
    id: "119.42.164.123",
    type: "custom",
    position: { x: 995, y: 650 },
    className: "gateway-small",
    data: { label: "119.42.164.123" },
    dragHandle: "noDrag",
  },
  {
    id: "197.238.77.25",
    type: "custom",
    position: { x: 1055, y: 733 },
    className: "gateway-small",
    data: { label: "197.238.77.25" },
    dragHandle: "noDrag",
  },
  {
    id: "4.206.89.123",
    type: "custom",
    position: { x: 1105, y: 663 },
    className: "gateway-small",
    data: { label: "4.206.89.123" },
    dragHandle: "noDrag",
  },
  {
    id: "174.12.151.6",
    type: "custom",
    position: { x: 1205, y: 590 },
    className: "gateway-small",
    data: { label: "174.12.151.6" },
    dragHandle: "noDrag",
  },
  {
    id: "148.115.20.236",
    type: "custom",
    position: { x: 1105, y: 1590 },
    className: "gateway-small",
    data: { label: "148.115.20.236" },
    dragHandle: "noDrag",
  },
  {
    id: "70.157.149.183",
    type: "custom",
    position: { x: 355, y: 620 },
    className: "gateway-small",
    data: { label: "70.157.149.183" },
    dragHandle: "noDrag",
  },
];
